import type { IconProps } from './types';
import './icons.css';

export default function Burger({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-burger ${className || ''}`}
    >
      <g fill="currentColor">
        <rect x="2" y="4" width="16" height="2" rx="1" />
        <rect x="2" y="9" width="16" height="2" rx="1" />
        <rect x="2" y="14" width="16" height="2" rx="1" />
      </g>
    </svg>
  );
}
